import { render, staticRenderFns } from "./annualbudgetcopy.vue?vue&type=template&id=b92fe39a&scoped=true"
import script from "./annualbudgetcopy.vue?vue&type=script&lang=js"
export * from "./annualbudgetcopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92fe39a",
  null
  
)

export default component.exports